import { LISTACCOUNTPROFILE } from "app/shared/services/services-model.type";
import { FETCH_TERM_DEPOSIT_LIST_REQUEST, FETCH_TERM_DEPOSIT_LIST_SUCCESS, FETCH_TERM_DEPOSIT_LIST_FAILURE } from "./actions.type";
import { FetchTermDepositListRequest, FetchTermDepositListSuccess, FetchTermDepositListFailure } from "./types";

export const fetchTermDepositListRequest = (): FetchTermDepositListRequest => ({
  type: FETCH_TERM_DEPOSIT_LIST_REQUEST,
});

export const fetchTermDepositListSuccess = (payload?: LISTACCOUNTPROFILE): FetchTermDepositListSuccess => ({
  type: FETCH_TERM_DEPOSIT_LIST_SUCCESS,
  payload,
});

export const fetchTermDepositListFailure = (payload?: string): FetchTermDepositListFailure => ({
  type: FETCH_TERM_DEPOSIT_LIST_FAILURE,
  payload,
});
